import { ReactNode } from 'react';

import { CssBaseline, StyledEngineProvider, ThemeProvider } from '@mui/material';

import { useTheme } from '../styles/theme';

export interface GlobalProvidersProps {
  children: ReactNode;
}

const GlobalProviders = ({ children }: GlobalProvidersProps) => {
  const theme = useTheme();
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default GlobalProviders;
